<template>
    <ac-modal :title="'Affiliation Link Generator'" ref="modalRef">
        <template>
            <div>
                <form class="form-group">
                    <label>Npi:
                        <input type="text" class="form-control" v-model="npi">
                    </label>
                    <ac-button :action="generateLink">GENERATE AFFILIATION LINK</ac-button>
                </form>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="input-group">
                            <input type="text" class="form-control" ref="linkUrl" v-model="link" readonly>
                            <span class="input-group-btn">
                                <ac-button class="btn btn-green provider-search-link-button" :action="copy">
                                    Copy
                                </ac-button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "AffiliationLinkGeneratorModal",
        data() {
            return {
                requesteeId: 0,
                npi: '',
                link: ''
            }
        },
        methods: {
            showModal(requesteeId) {
                this.requesteeId = requesteeId;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async generateLink() {
                let linkInfo = await api.post('Affiliation', `${this.requesteeId}/GetAffiliationLink/${this.npi}`, null);
                this.link = linkInfo.data;
            },
            copy() {
                this.$refs.linkUrl.select();
                document.execCommand('copy');
            }
        }
    }
</script>

<style scoped>

</style>